import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCall,
  postCall,
  deleteCall,
  getById,
  BASE_URL,
} from "../../utils/api";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
  data: [],
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getBank = createAsyncThunk(
  "Bank/get",
  async ({ query = "", page = 1, per_page = 50 }) => {
    try {
      const response = await getCall(
        `/admin/v1/all_bank?query=${query}&page=${page}&per_page=${per_page}`,
        false
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export const getBankById = createAsyncThunk("Bank/getById", async (id) => {
  try {
    const response = await getById("/admin/v1/show_bank", id, false);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const addBank = createAsyncThunk("Bank/add", async (data) => {
  try {
    const response = await postCall("/admin/v1/add_bank", data);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const updateBank = createAsyncThunk(
  "Bank/updateBank",
  async ({ id, formData }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/v1/update_bank/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message || "Bank updated successfully!");

      return response.data;
    } catch (error) {
      toast.error("Unable to update data. Please try again later.");

      return rejectWithValue(error.response.data);
    }
  }
);

export const multipleDeleteBank = createAsyncThunk(
"Bank/delete",
  async (id, { dispatch }) => {
    try {
      await deleteCall(`/admin/v1/delete_bank?bank_id=${id}`);
      return await id;
    } catch (error) {
      return Promise?.reject(error);
    } finally {
    }
  }
);

const BankSlice = createSlice({
  name: "Bank",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBank.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getBank.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getBank.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getBankById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getBankById.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(getBankById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(addBank.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addBank.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.push(action.payload);
      })
      .addCase(addBank.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updateBank.pending, (state) => {
        state.isUpdateStatus = "loading";
        state.error = null;
      })
      .addCase(updateBank.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        const index = state?.data?.data?.findIndex(
          (Bank) => Bank.id === action.payload?.data.id
        );
        if (index >= 0) {
          state.data.data[index] = action.payload.data;
        }
      })
      .addCase(updateBank.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })


      .addCase(multipleDeleteBank.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(multipleDeleteBank.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = state?.data?.data.filter(
          (Bank) => Bank.id !== action.payload
        );
      })
      .addCase(multipleDeleteBank.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default BankSlice.reducer;
